import { useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { useNetworkDebugRequests } from 'shared/lib/networkDebug'

import { NetworkRequestDetail } from './NetworkRequestDetail'
import { NetworkRequestList } from './NetworkRequestList'
import { NETWORK_DEBUG_TRANSLATION_KEYS } from './translations'

import styles from './NetworkDebugContent.module.scss'

const KEYS = NETWORK_DEBUG_TRANSLATION_KEYS

/** The session's requests on the left, the chosen one on the right; the latest is chosen until
 *  the admin picks another. */
export const NetworkDebugContent = () => {
  const requests = useNetworkDebugRequests()
  const [selectedId, setSelectedId] = useState<number | null>(null)
  const selected =
    requests.find((request) => request.id === selectedId) ?? requests[requests.length - 1]

  if (!selected) {
    return (
      <div className={styles.empty}>
        <span className={styles.emptyTitle}>
          <Translation text={KEYS.empty} span />
        </span>
        <Translation text={KEYS.emptyText} span />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <NetworkRequestList requests={requests} selectedId={selected.id} onSelect={setSelectedId} />
      <NetworkRequestDetail key={selected.id} request={selected} />
    </div>
  )
}

NetworkDebugContent.displayName = 'NetworkDebugContent'
